namespace TabAurous.OMS {
    export interface AddressMasterForm {
        LedgerId: Serenity.IntegerEditor;
        AddressType: Serenity.LookupEditor;
        Address1: Serenity.StringEditor;
        Address2: Serenity.StringEditor;
        Country: Serenity.LookupEditor;
        State: Serenity.LookupEditor;
        City: Serenity.LookupEditor;
        Pincode: Serenity.StringEditor;
        Default: _Ext.YesNoEditor;
        CityName: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        CountryName: Serenity.StringEditor;
    }

    export class AddressMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.AddressMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddressMasterForm.init)  {
                AddressMasterForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = _Ext.YesNoEditor;

                Q.initFormType(AddressMasterForm, [
                    'LedgerId', w0,
                    'AddressType', w1,
                    'Address1', w2,
                    'Address2', w2,
                    'Country', w1,
                    'State', w1,
                    'City', w1,
                    'Pincode', w2,
                    'Default', w3,
                    'CityName', w2,
                    'StateName', w2,
                    'CountryName', w2
                ]);
            }
        }
    }
}
